<template>
	<div class="container mt-5">
		<h2 class="mb-5 title is-size-4">{{ $route.params.name }}</h2>
		<div class="columns is-multiline">
			<template v-for="(g, j) in friendImages" :key="j">
				<div
					class="column is-flex is-align-items-center is-justify-content-center"
					:class="landscape[g] ? 'is-4' : 'is-2'"
				>
					<figure class="image thumb" :class="landscape[g] ? 'landscape' : 'portrait'" @click="openGameModal(g)">
						<img :src="g" @load="onImageLoad(g, $event)" />
					</figure>
				</div>
			</template>
		</div>
	</div>
	<div id="friend-modal" v-bind:hidden="!showModal">
		<div class="is-active modal">
			<div class="modal-background" @click="showModal = false"></div>
			<div class="modal-content">
				<figure class="image">
					<img id="modalImage" />
				</figure>
			</div>
			<button class="modal-close is-large" aria-label="close" @click="showModal = false"></button>
		</div>
	</div>
	<Transition name="fade">
		<back-to-top v-if="currentPage > 1"></back-to-top>
	</Transition>
</template>

<script>
import GALLERY from '@/gallery';
import BackToTop from '@/components/BackToTop.vue';
import customItems from '@/customItems.js';

export default {
	name: 'FriendCollectionView',
	components: { BackToTop },
	data() {
		return {
			currentPage: 1,
			perPage: 18,
			showModal: false,
			modalContent: null,
			landscape: {},
		};
	},
	computed: {
		gallery() {
			return [...customItems.getItems('gallery'), ...GALLERY];
		},
		friendImages() {
			return this.gallery
				.filter((g) => g.name.toLocaleLowerCase().includes(this.$route.params.name.toLocaleLowerCase()))[0]
				.image.src.slice(0, this.currentPage * this.perPage);
		},
	},
	methods: {
		onImageLoad(src, e) {
			const img = e.target;
			this.landscape[src] = img.naturalWidth > img.naturalHeight;
		},
		openGameModal(g) {
			let modalImg = document.getElementById('modalImage');

			modalImg.src = g;
			this.showModal = true;
		},
		handleScroll() {
			if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
				this.currentPage++;
			} else if (window.scrollY === 0) {
				this.currentPage = 1;
			}
		},
	},
	created() {
		this.currentPage = 1;
		window.addEventListener('scroll', this.handleScroll);
	},
	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style scoped>
.thumb {
	width: 100%;
	cursor: pointer;
	overflow: hidden;
	background-color: #111;
}
/* is-2 portrait (3:4) and is-4 landscape (3:2) end up the same height, so rows stay aligned */
.thumb.portrait {
	aspect-ratio: 3 / 4;
}
.thumb.landscape {
	aspect-ratio: 3 / 2;
}
.thumb img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}
#friend-modal .modal-content {
	width: auto;
	max-width: 90vw;
}
#friend-modal .image img {
	max-height: 90vh;
	width: auto;
	margin: 0 auto;
}
</style>
